import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import { ButtonRow } from '../../../../components/customer-self-setup-components/ButtonRow/ButtonRow';
import { UseStepperReturn } from '../../../../../shared/hooks/useStepper';
import { questionnaireStore } from '../../../../stores/customerSelfSetupStores/questionnaireStore';
import { useScrollToTop } from '../../../../../shared/hooks/useScrollToTop';
import { QuestionnaireForm } from '../../../../components/customer-self-setup-components';
import { entitySignUpStore } from '../../../../../shared/stores/entity/entitySignUpStore';

type QuestionnaireStepProps = {
  stepperMethods: UseStepperReturn;
};

const questionnaireFormId = 'questionnaireForm';

const QuestionnaireStep = observer(({ stepperMethods }: QuestionnaireStepProps) => {
  useScrollToTop();

  const { questions, userAnswers } = questionnaireStore;
  const { entityId } = entitySignUpStore;

  useEffect(() => {
    if (entityId && !questions.length) {
      questionnaireStore.getQuestions(entityId);
    }
  }, []);

  const handleFormSubmit = (data: Record<string, number>) => {
    questionnaireStore.setUserAnswers(data);
    stepperMethods.goToNextStep();
  };

  return (
    <div>
      <QuestionnaireForm
        formConfig={{ defaultValues: userAnswers }}
        questions={questions}
        onSubmit={handleFormSubmit}
        formId={questionnaireFormId}
      />
      <ButtonRow formId={questionnaireFormId} />
    </div>
  );
});

export { QuestionnaireStep };
